var baseStyle = {};
var codeBackgroundColor = 'rgba(16, 112, 202, 0.06)';
var codeBorderColor = 'rgba(16, 112, 202, 0.14)';
var appearances = {
  "default": {
    backgroundColor: codeBackgroundColor,
    boxShadow: "inset 0 0 0 1px ".concat(codeBorderColor),
    paddingX: 6,
    paddingY: 3,
    borderRadius: 'radii.1'
  }
};
var sizes = {};
export default {
  baseStyle: baseStyle,
  appearances: appearances,
  sizes: sizes
};